import React from 'react'
import './style.css'
const BlackFooter = () => {
  return (
      <div className='second_footer'>
      <ul className='second_nav_list'>
        <li><a href="/" className='black-foot_header'>Contact Us</a></li>
        <li className='dis'>I</li>
        <li><a href="/" className='black-foot_header'>Legal</a></li>
        <li className='dis'>I</li>
        <li><a href="/" className='black-foot_header'>Privacy and Security</a></li>
        <li className='dis'>I</li>
        <li> <a href="/" className='black-foot_header'>CICATE Trademarks</a></li>
      </ul>
      <div className='manage'> 
         <div className='copyright'> Copyright (C) 2023 by Educational Testing Service. All Rights reserved </div>
      <div className='copyright2'>All trademarks are the property of their respective owners</div> 
      
      </div>
     
     </div>

  )
}

export default BlackFooter
